








































import {Component, Prop} from "vue-property-decorator";
import {processError} from "@/utils/ComponentUtils";
import {namespace} from "vuex-class";
import {EmploymentVue} from "@/components/payroll/business/employments/EmploymentVue";
import {ContractorType} from "@/dto/payroll/IEmployment";
import {IndividualForeignContractorDTO} from "@/components/payroll/business/employments/foreignContractors/ForeignContractorPayloads";
import IndividualForeignContractorService from "@/components/payroll/business/employments/foreignContractors/IndividualForeignContractorService";
import ContractorDocumentDTO from "@/dto/contractor/ContractorDocumentDTO";
import AddContractorDocumentModal from "@/components/payroll/business/employments/contractors/AddContractorDocumentModal.vue";
import IndividualContractorService from "@/components/payroll/business/employments/contractors/IndividualContractorService";
import BusinessContractorService from "@/components/payroll/business/employments/contractors/BusinessContractorService";
import BusinessForeignContractorService from "@/components/payroll/business/employments/foreignContractors/BusinessForeignContractorService";
import {CounterpartyType} from "@/constants/CounterpartyType";
import {EmploymentType} from "@/constants/EmploymentType";

const AppModule = namespace("App");

@Component
export default class ContractorDocuments extends EmploymentVue<IndividualForeignContractorDTO> {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Prop()
  employment!: IndividualForeignContractorDTO

  private contractorDocuments: Array<ContractorDocumentDTO> = [];

  mounted(): void {
    this.loadDocuments();
  }

  loadDocuments(): void {
    this.startLoading();
    switch(this.getContractorType){
      case ContractorType.BUSINESS_FOREIGN:
        BusinessForeignContractorService.getDocuments(this.employment.id!).then(
            response => {
              this.contractorDocuments = response.data;
              this.stopLoading();
            },
            error => {
              processError(error, this);
              this.stopLoading();
            }
        );
        break
      case ContractorType.BUSINESS_DOMESTIC:
        BusinessContractorService.getDocuments(this.employment.id!).then(
            response => {
              this.contractorDocuments = response.data;
              this.stopLoading();
            },
            error => {
              processError(error, this);
              this.stopLoading();
            }
        );
        break
      case ContractorType.INDIVIDUAL_DOMESTIC:
        IndividualContractorService.getDocuments(this.employment.id!).then(
            response => {
              this.contractorDocuments = response.data;
              this.stopLoading();
            },
            error => {
              processError(error, this);
              this.stopLoading();
            }
        );
        break
      case ContractorType.INDIVIDUAL_FOREIGN:
        IndividualForeignContractorService.getDocuments(this.employment.id!).then(
            response => {
              this.contractorDocuments = response.data;
              this.stopLoading();
            },
            error => {
              processError(error, this);
              this.stopLoading();
            }
        );
        break
    }
  }

  get isForeignContractor(): boolean{
    return this.employment.employmentType == EmploymentType.FOREIGN;
  }



  showModal(): void {
    this.$modal.show(
        AddContractorDocumentModal,
        {onSuccess: this.loadDocuments, contractorType: this.getContractorType}
    );
  }

  get getContractorType(): ContractorType {
    switch (this.employment.counterpartyType){
      case CounterpartyType.COMPANY: switch (this.employment.employmentType){
        case EmploymentType.FOREIGN: return ContractorType.BUSINESS_FOREIGN;
        case EmploymentType.CONTRACTOR: return ContractorType.BUSINESS_DOMESTIC;
        default: throw new Error("Unknown contractor type");
      }
      case CounterpartyType.PERSON: switch (this.employment.employmentType) {
        case EmploymentType.FOREIGN: return ContractorType.INDIVIDUAL_FOREIGN;
        case EmploymentType.CONTRACTOR: return ContractorType.INDIVIDUAL_DOMESTIC;
        default: throw new Error("Unknown contractor type");
      }
      default: throw new Error("Unknown contractor type");
    }
  }

}

